import { validationRules } from "../../utils/validation";

// 🔹 Purchasers or Tenants
export const PurchaserEddInfoSchema = {
  PurchaserwealthSource: [
    validationRules.required("What is the source of the client/counterparty’s overall wealth? is required"),
  ],
  PurchaserTimeframeWealthAccumlated: [
    validationRules.required("Over what timeframe was this wealth accumulated? is required"),
  ],
  PurchaserHowPossessTheirOverallAssests: [
    validationRules.required("How and why does the individual/entity possess their overall assets? is required"),
  ],
  PurchaserIsRelationshipNew: [
    validationRules.required("Is this a new relationship? is required"),
  ],
  PurchaserStepsTakenToverifyWealth: [
    validationRules.required("Steps taken to verify the legitimacy of the wealth is required"),
  ],
  SourceOfFundForTransactionGenerated: [
    validationRules.required("Specify the source of funds for the transaction and how they were generated is required"),
  ],
  SourceBankName: [
    validationRules.required("Bank Name is required"),
  ],
  SourceAccountNumber: [
    validationRules.required("Bank Account Number is required"),
  ],
  PurchaserFundSourceVerifiedIndependently: [
    validationRules.required("Have the client’s instructions regarding the source of funds been independently verified? is required"),
  ],
};

// 🔹 Purchaser Conditional Fields
export const PurchaserClientKnownDuration = {
  PurchaserClientKnownDuration: [
    validationRules.required("How long have you known this client for? is required"),
  ],
};

export const PurchaseFundVerified = {
  PurchaseFundVerifiedDetail: [
    validationRules.required("Please provide details of how the funds were independently verified"),
  ],
};

// 🔹 Sellers or Landlords
export const SellerEddInfoSchema = {
  SellerWealthSource: [
    validationRules.required("What is the source of the seller's overall wealth? is required"),
  ],
  SellerTimeframeWealthAccumlated: [
    validationRules.required("Over what timeframe was this seller's wealth accumulated? is required"),
  ],
  SellerHowPossessTheirOverallAssests: [
    validationRules.required("How and why does the seller possess their overall assets? is required"),
  ],
  SellerIsRelationshipNew: [
    validationRules.required("Is this a new relationship? is required"),
  ],
  SellerStepsTakenToverifyWealth: [
    validationRules.required("Steps taken to verify the legitimacy of the seller's wealth: is required"),
  ],
  SellerBussinessNature: [
    validationRules.required("Describe the nature of the seller/landlord’s business is required"),
  ],
  SellerFundSourceVerifiedIndependently: [
    validationRules.required("Have steps been taken to independently verify this information? is required"),
  ],
  MortgageOnProperty: [
    validationRules.required("Is there a mortgage on the property? is required"),
  ],
  DestinationBankName: [
    validationRules.required("Seller’s Bank Name is required"),
  ],
  DestinationAccountNumber: [
    validationRules.required("Seller’s Bank Account Number is required"),
  ],
  FurthurInformation: [
    validationRules.required("Further information detailing the application of EDD is required"),
  ],
};

// 🔹 Seller Conditional Fields (if any)
export const MortgageBankName = {
  MortgageBankName: [
    validationRules.required("Mortgage Bank Name is required"),
  ],
};

// The Seller half renders this select on "Is this a new relationship? = No", exactly as the
// Purchaser half does — it just never had a schema, so it was never required.
export const SellerClientKnownDuration = {
  SellerClientKnownDuration: [
    validationRules.required("How long have you known this client for? is required"),
  ],
};

// Both halves render a free-text "Please specify" when the wealth source is "Other".
// Leaving it blank means the recorded source of wealth is literally "Other" — no answer at all.
export const PurchaserWealthSourceOther = {
  PurchaserWealthSourceOther: [
    validationRules.required("Please specify the source of the client/counterparty’s overall wealth"),
  ],
};

export const SellerWealthSourceOther = {
  SellerWealthSourceOther: [
    validationRules.required("Please specify the source of the seller’s overall wealth"),
  ],
};
